import script from "./Classifiers.vue?vue&type=script&setup=true&lang=js"
export * from "./Classifiers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c52aa08"]])

export default __exports__